import { Controller } from 'stimulus';
import Rails from '@rails/ujs';
import { get } from '@rails/request.js'

export default class extends Controller {
	static targets = ["tippingUrl", "allowScreenshot"]

	async fillModelInfo(event) {
		const userId = event.target.value;
		const response = await get(`/usr/${userId}`, {responseKind: "json"})
		if (response.ok) {
			const user = await response.json
			this.tippingUrlTarget.value = user.tipping_url
			this.allowScreenshotTarget.checked = user.screenshot_policy
		}
	}
}
